
const state = {
  agency_id: null,
  id: null,
  price_override: null,
}

export const requiredFields = [
  { key: 'agency_id' },
]

export default state
